import * as apiGetReportList from 'apiAuto/report/paths/Getv1fileslistV1';
import * as Report from 'containers/desktop/Reports/types/Report';

export * as ReportList from 'containers/desktop/Reports/types/ReportList';

export type Type = Report.Type[];

export function create(): Type {
	return [];
}

export async function getFromApi() {
	const response = (await apiGetReportList.callApi()).getOrDefault([]);
	return response.map(Report.mapFromApi);
}

export function setSelectedToFalse(reportList: Type): Type {
	return reportList.map(Report.setSelectedToFalse);
}

export function setSelectedToTrue(reportList: Type): Type {
	return reportList.map(Report.setSelectedToTrue);
}
